import { render, staticRenderFns } from "./IconeResumo.vue?vue&type=template&id=7b7e1a38&scoped=true&"
import script from "./IconeResumo.vue?vue&type=script&lang=js&"
export * from "./IconeResumo.vue?vue&type=script&lang=js&"
import style0 from "./IconeResumo.vue?vue&type=style&index=0&id=7b7e1a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e1a38",
  null
  
)

export default component.exports